var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import Modernizr from 'modernizr';
import { fromEvent, merge } from 'rxjs';
export var Fullscreen;
(function (Fullscreen) {
    function toggleFullscreen(element) {
        var fullscreenElement = getFullscreenElement();
        (fullscreenElement === null) ? requestFullscreen(element) : exitFullscreen();
    }
    Fullscreen.toggleFullscreen = toggleFullscreen;
    // Request fullscreen
    function requestFullscreen(element) {
        if (checkFullscreenSupport()) {
            if (!element) {
                element = document.body;
            }
            if (Fullscreen.isFullscreen()) {
                return;
            }
            var fn = Modernizr.prefixed('requestFullscreen', document.body);
            fn();
        }
    }
    Fullscreen.requestFullscreen = requestFullscreen;
    // Exit fullscreen
    function exitFullscreen() {
        if (checkFullscreenSupport()) {
            var fn = Modernizr.prefixed('exitFullscreen', document);
            fn();
        }
    }
    Fullscreen.exitFullscreen = exitFullscreen;
    // Is fullscreen supported by the browser, and the potential parent iframe
    function canFullscreen() {
        return Modernizr.fullscreen && Modernizr.prefixed('fullscreenEnabled', document);
    }
    Fullscreen.canFullscreen = canFullscreen;
    // More verbose canFullscreen
    function checkFullscreenSupport() {
        if (canFullscreen()) {
            return true;
        }
        else {
            console.warn('Fullscreen is not enabled');
            return false;
        }
    }
    Fullscreen.checkFullscreenSupport = checkFullscreenSupport;
    // Return the current fullscreen element, or null
    function getFullscreenElement() {
        return Modernizr.prefixed('fullscreenElement', document);
    }
    Fullscreen.getFullscreenElement = getFullscreenElement;
    // Utility function to check if we're in full screen
    function isFullscreen() {
        return getFullscreenElement() != null;
    }
    Fullscreen.isFullscreen = isFullscreen;
    function onFullscreenChange() {
        var events$ = 'mozfullscreenchange webkitfullscreenchange MSFullscreenChange fullscreenchange'
            .split(' ')
            .map(function (event) {
            return fromEvent(document.body, event);
        });
        return merge.apply(void 0, __spread(events$));
    }
    Fullscreen.onFullscreenChange = onFullscreenChange;
})(Fullscreen || (Fullscreen = {}));
